import useLocalBufferPort from '@UI/Providers/PortsProvider/Hooks/LocalBuffer/useLocalBufferPort';
import * as React from 'react';

export type RecoveredChunkCount =
	| { readonly type: 'loading' }
	| { readonly type: 'read'; readonly chunkCount: number }
	| { readonly type: 'failed' };

/** Counts the fragments the local buffer still holds for a queue item. */
const useRecoveredChunkCount = (itemId: string): RecoveredChunkCount => {
	const localBufferPort = useLocalBufferPort();
	const [recovered, setRecovered] = React.useState<RecoveredChunkCount>({ type: 'loading' });

	React.useEffect(() => {
		let isCancelled = false;
		setRecovered({ type: 'loading' });
		localBufferPort
			.listSegments(itemId)
			.then((segments) => {
				if (!isCancelled) {
					setRecovered({
						type: 'read',
						chunkCount: segments.reduce((total, segment) => total + segment.chunkCount, 0),
					});
				}
			})
			.catch(() => {
				if (!isCancelled) {
					setRecovered({ type: 'failed' });
				}
			});

		return () => {
			isCancelled = true;
		};
	}, [localBufferPort, itemId]);

	return recovered;
};

export default useRecoveredChunkCount;
